import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AutoComplete } from 'primeng/autocomplete';
import * as i0 from "@angular/core";
import * as i1 from "@angular/forms";
import * as i2 from "@ngx-translate/core";
import * as i3 from "@angular/common";
import * as i4 from "../field-error/field-error.component";
import * as i5 from "ngx-skeleton-loader";
import * as i6 from "primeng/autocomplete";
import * as i7 from "../button-v2/button.component";
import * as i8 from "../icon-v2/icon.component";
const _c0 = () => [];
const _c1 = () => ({
  height: "40px",
  width: "100%"
});
function SearchBarV2Component_div_0_geaui_button_v2_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-button-v2", 9);
    i0.ɵɵlistener("click", function SearchBarV2Component_div_0_geaui_button_v2_3_Template_geaui_button_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r3);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.searchButtonClick());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("disabled", ctx_r1.isDisabled)("sending", ctx_r1.sending)("loading", ctx_r1.loading)("type", "primary");
  }
}
function SearchBarV2Component_div_0_geaui_icon_v2_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "geaui-icon-v2", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("color", ctx_r1.isDisabled ? "grey" : "blue");
  }
}
function SearchBarV2Component_div_0_geaui_icon_v2_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "geaui-icon-v2", 11);
    i0.ɵɵlistener("click", function SearchBarV2Component_div_0_geaui_icon_v2_5_Template_geaui_icon_v2_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r1 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r1.clearValue());
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", ctx_r1.hasProminentButton ? "search-bar-button-remove-prominent" : "search-bar-button-remove-reduced")("file", "16px_close")("clickable", true);
  }
}
function SearchBarV2Component_div_0_label_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "label", 12);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("for", ctx_r1.id);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind1(2, 2, ctx_r1.label), " ");
  }
}
function SearchBarV2Component_div_0_ngx_skeleton_loader_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "ngx-skeleton-loader", 13);
  }
  if (rf & 2) {
    i0.ɵɵproperty("theme", i0.ɵɵpureFunction0(1, _c1));
  }
}
function SearchBarV2Component_div_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 1)(1, "p-autoComplete", 2);
    i0.ɵɵpipe(2, "translate");
    i0.ɵɵlistener("onLazyLoad", function SearchBarV2Component_div_0_Template_p_autoComplete_onLazyLoad_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.onLazyLoad.emit($event));
    })("completeMethod", function SearchBarV2Component_div_0_Template_p_autoComplete_completeMethod_1_listener($event) {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.search($event));
    })("onShow", function SearchBarV2Component_div_0_Template_p_autoComplete_onShow_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.disableBorder());
    })("onHide", function SearchBarV2Component_div_0_Template_p_autoComplete_onHide_1_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.enableBorder());
    });
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SearchBarV2Component_div_0_geaui_button_v2_3_Template, 1, 4, "geaui-button-v2", 3)(4, SearchBarV2Component_div_0_geaui_icon_v2_4_Template, 1, 1, "geaui-icon-v2", 4)(5, SearchBarV2Component_div_0_geaui_icon_v2_5_Template, 1, 3, "geaui-icon-v2", 5)(6, SearchBarV2Component_div_0_label_6_Template, 3, 4, "label", 6);
    i0.ɵɵelement(7, "geaui-field-error", 7);
    i0.ɵɵtemplate(8, SearchBarV2Component_div_0_ngx_skeleton_loader_8_Template, 1, 2, "ngx-skeleton-loader", 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_8_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("formGroup", ctx_r1.group)("ngClass", ctx_r1.alwaysFloatLabel ? "gea-always-float-label" : "");
    i0.ɵɵadvance();
    i0.ɵɵclassProp("has-prominent-button", ctx_r1.hasProminentButton);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.id);
    i0.ɵɵproperty("readonly", ctx_r1.isDisabled)("disabled", ctx_r1.isDisabled)("placeholder", i0.ɵɵpipeBind1(2, 25, ctx_r1.placeholder))("formControlName", (tmp_8_0 = ctx_r1.formName) !== null && tmp_8_0 !== undefined ? tmp_8_0 : ctx_r1.id)("minLength", 0)("inputStyleClass", ctx_r1.showBottomBorderOnly ? "border-only-bottom" : "")("styleClass", ctx_r1.isDisabled ? "custom-disable" : "")("suggestions", ctx_r1.hasSuggestions ? ctx_r1.filteredResults : i0.ɵɵpureFunction0(27, _c0))("virtualScroll", ctx_r1.virtualScroll)("virtualScrollItemSize", ctx_r1.virtualScrollItemSize)("virtualScrollOptions", ctx_r1.virtualScrollOptions)("lazy", ctx_r1.lazy)("overlayOptions", ctx_r1.getOverlayOptions());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.hasProminentButton);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.hasProminentButton && !ctx_r1.control.value);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.control.value && !ctx_r1.isDisabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.label && ctx_r1.alwaysFloatLabel);
    i0.ɵɵadvance();
    i0.ɵɵproperty("withIcon", false)("errors", ctx_r1.control == null ? null : ctx_r1.control.errors);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.loading);
  }
}
export class SearchBarV2Component {
  formBuilder;
  translate;
  id = 'search-bar';
  formName = undefined;
  label = '';
  loading = false;
  sending = false;
  disabled = false;
  hasProminentButton = true;
  placeholder = '';
  group;
  set initialValue(initialValue) {
    this._initialValue = initialValue;
    this.control?.setValue(initialValue);
  }
  searchResults = [];
  required = false;
  hasSuggestions = true;
  showBottomBorderOnly = false;
  alwaysFloatLabel = false;
  virtualScroll = false;
  virtualScrollItemSize;
  virtualScrollOptions;
  lazy = false;
  // keeping the property name as onLazyLoad to match the primeNG event name
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  onLazyLoad = new EventEmitter();
  valueChanged = new EventEmitter();
  searchButtonClicked = new EventEmitter();
  clearEvent = new EventEmitter();
  isBorderDisabled = false;
  filteredResults = [];
  defaultControl;
  subscriptions = [];
  _initialValue = '';
  autocompleteControl;
  constructor(formBuilder, translate) {
    this.formBuilder = formBuilder;
    this.translate = translate;
    // eslint thinks we are trying to assign null
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    this.defaultControl = new FormControl(this._initialValue, []);
    this.group = this.group || this.formBuilder.group({
      [this.formName ?? this.id]: this.defaultControl
    });
  }
  get control() {
    return this.group?.get(this.formName ?? this.id);
  }
  get isDisabled() {
    return this.control?.disabled;
  }
  ngOnInit() {
    if (this.id === '') {
      throw new Error('please provide an id for the form field');
    }
    if (this._initialValue) {
      this.control?.setValue(this._initialValue);
    }
    if (this.required) {
      this.addRequiredValidationToControl();
    }
    const sub = this.control?.valueChanges.subscribe(value => this.valueChanged.emit(value));
    if (sub) this.subscriptions.push(sub);
  }
  ngOnChanges(changes) {
    if (changes['disabled']) {
      const isDisabled = changes['disabled'].currentValue;
      isDisabled ? this.control?.disable() : this.control?.enable();
    }
  }
  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
  getOverlayOptions() {
    return {
      listener: (event, options) => {
        if (options?.type === 'scroll' || options?.type === 'resize') {
          return false;
        }
        return options?.valid;
      }
    };
  }
  clearValue() {
    this.control?.setValue('');
    this._initialValue = '';
    this.clearEvent.emit();
  }
  searchButtonClick() {
    this.searchButtonClicked.emit(this.control?.value);
  }
  search(event) {
    const hasSearchResults = !!(this.searchResults && this.control?.value);
    if (!hasSearchResults) {
      this.clearControlError('notFound');
    }
    this.filteredResults = this.searchResults.filter(option => option.toLowerCase().includes(event.query.toLowerCase()));
    if (this.hasSuggestions && this.filteredResults.length === 0) {
      this.setControlError('notFound');
    }
  }
  enableBorder() {
    setTimeout(() => {
      this.isBorderDisabled = false;
    });
  }
  disableBorder() {
    setTimeout(() => {
      this.isBorderDisabled = true;
    });
  }
  showErrorMessage() {
    return this.translate.instant('UI-LIB.ERROR-DIALOG.SEARCH.NO-RESULTS-FOUND');
  }
  onClear() {
    this.control?.reset();
    this.clearEvent.emit();
  }
  addRequiredValidationToControl() {
    this.control?.setValidators(Validators.required);
    this.control?.updateValueAndValidity();
  }
  setControlError(errorKey) {
    const errors = this.control?.errors;
    if (errors) {
      delete errors[errorKey];
      this.control?.setErrors(errors);
    }
  }
  clearControlError(errorKey) {
    const errors = this.control?.errors;
    if (errors) {
      errors[errorKey] = false;
      this.control?.setErrors(errors);
    }
  }
  static ɵfac = function SearchBarV2Component_Factory(t) {
    return new (t || SearchBarV2Component)(i0.ɵɵdirectiveInject(i1.FormBuilder), i0.ɵɵdirectiveInject(i2.TranslateService));
  };
  static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: SearchBarV2Component,
    selectors: [["geaui-search-bar-v2"]],
    viewQuery: function SearchBarV2Component_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(AutoComplete, 5);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.autocompleteControl = _t.first);
      }
    },
    inputs: {
      id: "id",
      formName: "formName",
      label: "label",
      loading: "loading",
      sending: "sending",
      disabled: "disabled",
      hasProminentButton: "hasProminentButton",
      placeholder: "placeholder",
      group: "group",
      initialValue: "initialValue",
      searchResults: "searchResults",
      required: "required",
      hasSuggestions: "hasSuggestions",
      showBottomBorderOnly: "showBottomBorderOnly",
      alwaysFloatLabel: "alwaysFloatLabel",
      virtualScroll: "virtualScroll",
      virtualScrollItemSize: "virtualScrollItemSize",
      virtualScrollOptions: "virtualScrollOptions",
      lazy: "lazy"
    },
    outputs: {
      onLazyLoad: "onLazyLoad",
      valueChanged: "valueChanged",
      searchButtonClicked: "searchButtonClicked",
      clearEvent: "clearEvent"
    },
    features: [i0.ɵɵNgOnChangesFeature],
    decls: 1,
    vars: 1,
    consts: [["class", "gea-search-bar-container gea-form-container-margin", 3, "formGroup", "ngClass", 4, "ngIf"], [1, "gea-search-bar-container", "gea-form-container-margin", 3, "formGroup", "ngClass"], ["data-cy", "input", 3, "onLazyLoad", "completeMethod", "onShow", "onHide", "id", "readonly", "disabled", "placeholder", "formControlName", "minLength", "inputStyleClass", "styleClass", "suggestions", "virtualScroll", "virtualScrollItemSize", "virtualScrollOptions", "lazy", "overlayOptions"], ["class", "search-bar-button", "preIcon", "search", "data-cy", "search", 3, "disabled", "sending", "loading", "type", "click", 4, "ngIf"], ["class", "search-bar-button-reduced", "file", "16px_search", "data-cy", "search", 3, "color", 4, "ngIf"], ["data-cy", "remove", 3, "ngClass", "file", "clickable", "click", 4, "ngIf"], ["data-cy", "label", 3, "for", 4, "ngIf"], [3, "withIcon", "errors"], ["count", "1", "appearance", "line", 3, "theme", 4, "ngIf"], ["preIcon", "search", "data-cy", "search", 1, "search-bar-button", 3, "click", "disabled", "sending", "loading", "type"], ["file", "16px_search", "data-cy", "search", 1, "search-bar-button-reduced", 3, "color"], ["data-cy", "remove", 3, "click", "ngClass", "file", "clickable"], ["data-cy", "label", 3, "for"], ["count", "1", "appearance", "line", 3, "theme"]],
    template: function SearchBarV2Component_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵtemplate(0, SearchBarV2Component_div_0_Template, 9, 28, "div", 0);
      }
      if (rf & 2) {
        i0.ɵɵproperty("ngIf", !ctx.loading);
      }
    },
    dependencies: [i3.NgClass, i3.NgIf, i1.NgControlStatus, i1.NgControlStatusGroup, i1.FormGroupDirective, i1.FormControlName, i4.FieldErrorComponent, i5.NgxSkeletonLoaderComponent, i6.AutoComplete, i7.ButtonV2Component, i8.IconComponent, i2.TranslatePipe],
    encapsulation: 2
  });
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(SearchBarV2Component, [{
    type: Component,
    args: [{
      selector: 'geaui-search-bar-v2',
      template: "<div\n  class=\"gea-search-bar-container gea-form-container-margin\"\n  *ngIf=\"!loading\"\n  [formGroup]=\"group\"\n  [ngClass]=\"alwaysFloatLabel ? 'gea-always-float-label' : ''\">\n  <p-autoComplete\n    id=\"{{ id }}\"\n    [class.has-prominent-button]=\"hasProminentButton\"\n    [readonly]=\"isDisabled\"\n    [disabled]=\"isDisabled\"\n    [placeholder]=\"placeholder | translate\"\n    [formControlName]=\"this.formName ?? this.id\"\n    [minLength]=\"0\"\n    [inputStyleClass]=\"showBottomBorderOnly ? 'border-only-bottom' : ''\"\n    [styleClass]=\"isDisabled ? 'custom-disable' : ''\"\n    [suggestions]=\"hasSuggestions ? filteredResults : []\"\n    [virtualScroll]=\"virtualScroll\"\n    [virtualScrollItemSize]=\"virtualScrollItemSize\"\n    [virtualScrollOptions]=\"virtualScrollOptions\"\n    [lazy]=\"lazy\"\n    [overlayOptions]=\"getOverlayOptions()\"\n    (onLazyLoad)=\"onLazyLoad.emit($event)\"\n    (completeMethod)=\"search($event)\"\n    (onShow)=\"disableBorder()\"\n    (onHide)=\"enableBorder()\"\n    data-cy=\"input\">\n  </p-autoComplete>\n  <geaui-button-v2\n    class=\"search-bar-button\"\n    *ngIf=\"hasProminentButton\"\n    [disabled]=\"isDisabled\"\n    [sending]=\"sending\"\n    [loading]=\"loading\"\n    [type]=\"'primary'\"\n    (click)=\"searchButtonClick()\"\n    preIcon=\"search\"\n    data-cy=\"search\">\n  </geaui-button-v2>\n  <geaui-icon-v2\n    class=\"search-bar-button-reduced\"\n    *ngIf=\"!hasProminentButton && !control.value\"\n    [color]=\"isDisabled ? 'grey' : 'blue'\"\n    file=\"16px_search\"\n    data-cy=\"search\">\n  </geaui-icon-v2>\n  <geaui-icon-v2\n    *ngIf=\"control.value && !isDisabled\"\n    [ngClass]=\"hasProminentButton ? 'search-bar-button-remove-prominent' : 'search-bar-button-remove-reduced'\"\n    [file]=\"'16px_close'\"\n    [clickable]=\"true\"\n    (click)=\"clearValue()\"\n    data-cy=\"remove\">\n  </geaui-icon-v2>\n  <label *ngIf=\"label && alwaysFloatLabel\" [for]=\"id\" data-cy=\"label\">\n    {{ label | translate }}\n  </label>\n  <geaui-field-error [withIcon]=\"false\" [errors]=\"control?.errors\"></geaui-field-error>\n  <ngx-skeleton-loader *ngIf=\"loading\" [theme]=\"{ height: '40px', width: '100%' }\" count=\"1\" appearance=\"line\">\n  </ngx-skeleton-loader>\n</div>\n"
    }]
  }], () => [{
    type: i1.FormBuilder
  }, {
    type: i2.TranslateService
  }], {
    id: [{
      type: Input
    }],
    formName: [{
      type: Input
    }],
    label: [{
      type: Input
    }],
    loading: [{
      type: Input
    }],
    sending: [{
      type: Input
    }],
    disabled: [{
      type: Input
    }],
    hasProminentButton: [{
      type: Input
    }],
    placeholder: [{
      type: Input
    }],
    group: [{
      type: Input
    }],
    initialValue: [{
      type: Input
    }],
    searchResults: [{
      type: Input
    }],
    required: [{
      type: Input
    }],
    hasSuggestions: [{
      type: Input
    }],
    showBottomBorderOnly: [{
      type: Input
    }],
    alwaysFloatLabel: [{
      type: Input
    }],
    virtualScroll: [{
      type: Input
    }],
    virtualScrollItemSize: [{
      type: Input
    }],
    virtualScrollOptions: [{
      type: Input
    }],
    lazy: [{
      type: Input
    }],
    onLazyLoad: [{
      type: Output
    }],
    valueChanged: [{
      type: Output
    }],
    searchButtonClicked: [{
      type: Output
    }],
    clearEvent: [{
      type: Output
    }],
    autocompleteControl: [{
      type: ViewChild,
      args: [AutoComplete]
    }]
  });
})();
